import { MAX_RECORD_TIME } from "@/constants";
import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

export enum RecordStatus {
  UNSTART,
  RECORDING,
  PAUSED,
  FINISHED,
}

export const disabledRecordStatus = [RecordStatus.RECORDING, RecordStatus.PAUSED]

interface TimingStore {
  atlast: boolean;
  recordStatus: RecordStatus;
  recordTime: number;
  recordWarning: boolean;
  pauseOrResumeLoading: boolean;
  finishLoading: boolean;
  startLoading: boolean;
  resetStore: () => void;
  startTiming: () => void;
  pauseTiming: () => void;
  stopTiming: () => void;
  setPauseOrResumeLoading: (pauseOrResumeLoading: boolean) => void;
  setFinishLoading: (finishLoading: boolean) => void;
  setStartLoading: (startLoading: boolean) => void;
}

const init_data = {
  recordStatus: RecordStatus.UNSTART,
  recordTime: 0,
  recordWarning: false,
  atlast: false,
  pauseOrResumeLoading: false,
  finishLoading: false,
  startLoading: false
};

let timer: NodeJS.Timeout;

const timingStore = create(
  subscribeWithSelector<TimingStore>((set, get) => ({
    ...init_data,
    startTiming: () => {
      set(() => ({ recordStatus: RecordStatus.RECORDING, pauseOrResumeLoading: false, finishLoading: false }));
      timer && clearInterval(timer);
      timer = setInterval(() => {
        const { recordTime } = get();
        const time = recordTime + 1;
        if (time >= MAX_RECORD_TIME) {
          set(() => ({
            recordStatus: RecordStatus.FINISHED,
            recordTime: MAX_RECORD_TIME,
            atlast: false,
          }));
          return;
        } else if (MAX_RECORD_TIME - time <= 5 * 60) {
          set(() => ({ recordTime: time, atlast: true }));
        } else {
          set(() => ({ recordTime: time }));
        }
      }, 1000);
    },
    pauseTiming: () => {
      clearInterval(timer);
      set(() => ({ recordStatus: RecordStatus.PAUSED }));
    },
    stopTiming: () => {
      clearInterval(timer);
      set({ recordStatus: RecordStatus.FINISHED });
    },
    resetStore: () => {
      clearInterval(timer);
      set(() => ({ ...init_data }));
    },
    setPauseOrResumeLoading: (pauseOrResumeLoading: boolean) => {
      set(() => ({ pauseOrResumeLoading }));
    },
    setFinishLoading: (finishLoading: boolean) => {
      set(() => ({ finishLoading }));
    },
    setStartLoading: (startLoading: boolean) => {
      set(() => ({ startLoading }));
    },
  }))
);

export default timingStore;
